<template>
    <div class="engineering">
        <el-container>
            <el-main ref="main" class="tabWrap">
                <el-tabs  v-model="activeName" style="width: 100%">
                    <el-tab-pane label="基本信息" name="Tab1">
                        <div>
                            <div class="container">
                                <el-form class="dataFormBox" :inline="true" :model="engineerList">
                                    <el-row>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="项目部：">
                                                <el-input v-model="engineerList.projectDeptName" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="项目名称：">
                                                <el-input v-model="engineerList.projectName" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="细目名称：">
                                                <el-input v-model="engineerList.subCategoryName" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="细目编码：">
                                                <el-input v-model="engineerList.subCategoryNo" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="单位：">
                                                <el-input v-model="engineerList.unit" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="单价：">
                                                <el-input v-model="engineerList.unitPrice" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="合同数量：">
                                                <el-input v-model="engineerList.contractCount" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="合同合价：">
                                                <el-input v-model="engineerList.contractSumPrice" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="核实数量：">
                                                <el-input v-model="engineerList.checkCount" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label-width="120px" label="核实合价：">
                                                <el-input v-model="engineerList.checkSumPrice" :readonly="true" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="目标成本" name="Tab2">
                        <div>
                            <el-form class="dataFormBox" :inline="true" :model="engineerList">
                                <el-row>
                                    <el-col :span="8">
                                        <el-form-item label-width="120px" label="合计-合价：">
                                            <el-input v-model="engineerList.sumPrice" :readonly="true" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label-width="120px" label="合计-单价：">
                                            <el-input v-model="engineerList.sumOnePrice" :readonly="true" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="8">
                                        <el-form-item label-width="120px" label="劳务合价：">
                                            <el-input v-model="engineerList.laborItemSumPrice" :readonly="true" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label-width="120px" label="材料合价：">
                                            <el-input v-model="engineerList.materialItemSumPrice" :readonly="true" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label-width="120px" label="机械合价：">
                                            <el-input v-model="engineerList.machineItemSumPrice" :readonly="true" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label-width="120px" label="其他合价：">
                                            <el-input v-model="engineerList.otherItemSumPrice" :readonly="true" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>

                            <div class="container">
                                <delete-module class="deleteModule" :list.sync="engineerList.laborItemList" titleTxt="劳务信息"></delete-module>
                                <delete-module class="deleteModule" :list.sync="engineerList.materialItemList" titleTxt="材料信息" ></delete-module>
                                <delete-module class="deleteModule" :list.sync="engineerList.machineItemList" titleTxt="机械信息"></delete-module>
                                <delete-module class="deleteModule" :list.sync="engineerList.otherItemList" titleTxt="其他"></delete-module>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="审批过程" name="Tab3">
                        <div v-if="approveFlag === 'currentApprove'">
                            <approveItem
                                    :itemId="contractId"
                                    :approveType="approveType"
                                    :subapproveType="subapproveType"
                                    @finishApprove="reset()"
                            >
                            </approveItem>
                        </div>
                        <div v-else>
                            <approveLine
                                    :itemId="contractId"
                                    :approveType="approveType"
                            ></approveLine>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </el-main>
            <el-footer class="containerBox">
                <div class="btnMid">
                    <el-button type="info" @click="reset()">关 闭</el-button>
                </div>
            </el-footer>
        </el-container>

    </div>
</template>

<script>
    import deleteModule from '../delete-module'
    import {
        queryFrontDetailService,
        queryApproveProcessService,
    } from '../../../services/engineering'

    import approveLine from "@/page/approveComponents/ApproveHistoryLine"; //历史审批流程
    import approveItem from "@/page/approveComponents/ApproveItem";
    import {goBackApprove} from '@/page/approveComponents/approve';
    export default {
        name: "infoDetails",
        data(){
            return {
                activeName: 'Tab1',

                dataForm: {},
                approveList: [], // 审批流列表
                engineerList: [], //详情列表
                index: 1, // 1 列表  2审批列表

                approveFlag: '', //审批状态
                approveType: "PROJECT_FRONT", //审批类型
                subapproveType: '',
                contractId: 0,
            }
        },
        components:{
            deleteModule,
            approveLine, //审批历史流程
            approveItem, //审批
        },
        methods:{
            onActive(menuCode) {
                this.projectDetailsFrontId = this.tabRouteParam.id
                this.index = this.tabRouteParam.index
                this.getFrontDetail()
                this.queryApproveProcess()

                this.approveFlag = this.tabRouteParam
                    ? this.tabRouteParam.approveFlag
                    : "";
                this.contractId = Number(this.tabRouteParam.id);
            },
            // 获取详情信息
            getFrontDetail(){
                let paramsData = {
                    projectDetailsFrontId: this.projectDetailsFrontId
                }
                queryFrontDetailService(paramsData).then( res => {
                    if(res.code == 10000000){
                        res.data.sumPrice = 0;

                        res.data.laborItemSumPrice = 0;
                        res.data.laborItemList.map( item => {
                            res.data.laborItemSumPrice += Number(item.unitSumPrice)
                            res.data.sumPrice += Number(item.unitSumPrice)
                        })
                        res.data.materialItemSumPrice = 0;
                        res.data.materialItemList.map( item => {
                            res.data.materialItemSumPrice += Number(item.unitSumPrice)
                            res.data.sumPrice += Number(item.unitSumPrice)
                        })

                        res.data.machineItemSumPrice = 0;
                        res.data.machineItemList.map( item => {
                            res.data.machineItemSumPrice += Number(item.unitSumPrice)
                            res.data.sumPrice += Number(item.unitSumPrice)
                        })

                        res.data.otherItemSumPrice = 0;
                        res.data.otherItemList.map( item => {
                            res.data.otherItemSumPrice += Number(item.unitSumPrice)
                            res.data.sumPrice += Number(item.unitSumPrice)
                        })
                        res.data.laborItemSumPrice = (res.data.laborItemSumPrice).toFixed(2)
                        res.data.materialItemSumPrice = (res.data.materialItemSumPrice).toFixed(2)
                        res.data.machineItemSumPrice = (res.data.machineItemSumPrice).toFixed(2)
                        res.data.otherItemSumPrice = (res.data.otherItemSumPrice).toFixed(2)
                        res.data.sumPrice = (res.data.sumPrice).toFixed(2)
                        res.data.sumOnePrice = Number(res.data.sumPrice) == 0? '0.00' : (Number(res.data.sumPrice)/Number(res.data.checkCount)).toFixed(2)
                        this.engineerList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            // 获取审批列表
            queryApproveProcess(){
                let paramsData = {
                    itemId: this.projectDetailsFrontId,
                    approveClass: 'PROJECT_FRONT'
                }
                queryApproveProcessService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.approveList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            reset(){
                if(this.approveFlag){
                    goBackApprove(this.approveFlag,'beforInfoDetails')
                }else{
                    this.bus.$emit("tabClose", "beforInfoDetails");
                    this.bus.$emit("navMenuChange", {
                        routeId: "beforIndex"
                    });
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .engineering {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
        .tabWrap {
        height: calc(100% - 60px);

        /deep/ .el-tabs--top {
          height: 100%;
          overflow: hidden;

          .el-tabs__content {
            height: calc(100% - 140px);
            padding: 0 20px 20px;
            overflow: auto;

            .el-form-item {
              width: 100%;
            }

            .el-checkbox {
              line-height: 40px;
            }

            .el-textarea {
              min-width: 0px !important;
            }
            .el-cascader {
              width: 100%;
            }

            .el-form-item__content {
              width: calc(100% - 150px);

              .el-input {
                width: 100%;
              }
            }
          }
        }
      }
    }
    .titleBox{
        display: flex;
        color: rgba(16, 16, 16, 100);
        font-size: 16px;
        text-align: left;
        font-family: SourceHanSansSC-regular;
        font-weight: 600;
        border-bottom: 1px solid rgba(187, 187, 187, 100);
        margin:30px 20px 0;
        padding-bottom: 10px;
        .titleNum{
            margin-left: 30px;
        }
    }
    .dataFormBox{
        margin:30px 0px;
    }
    /deep/.el-tabs__item{
        padding: 0 20px !important;
    }

    .containerBox {
        width: 100%;
        height: 36px !important;
        position: fixed;
        bottom: 44px;
        left: 0;
        text-align: start;
    }
    .btnMid {
        position: relative;
        left: 27%;
        bottom: 0px;
        display: flex;
    }
    /deep/.ApproveItem .bottomBtn{
        bottom: 44px;
        z-index: 10;
    }
</style>
